import { render } from "./BackTop.vue?vue&type=template&id=60c25154&scoped=true"
import script from "./BackTop.vue?vue&type=script&lang=js"
export * from "./BackTop.vue?vue&type=script&lang=js"

import "./BackTop.vue?vue&type=style&index=0&id=60c25154&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_736573a84b094314044e4eeca7aa4b54/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c25154"]])

export default __exports__